
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SapOrderContainer } from '@/api';

@Component({
  components: {},
})
export default class OrderContainerList extends Vue {
  @Prop({ type: Array, default: [] })
  containers!: SapOrderContainer[];

  detailActive = false;

  get shortCount(): number {
    return 2;
  }

  get shortList(): SapOrderContainer[] {
    return this.containers.slice(0, this.shortCount);
  }

  get remainingCount(): number {
    return this.containers.length - this.shortCount;
  }
}
